'use client';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getParcelSizes } from '@/store/calculatorStore';
import { ParcelSizeType } from '@/lib/type/type';

interface ReduxInitializerProps {
    packagingOptions: ParcelSizeType[];
}

export function ReduxInitializer({ packagingOptions }: ReduxInitializerProps) {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getParcelSizes(packagingOptions));
    }, [packagingOptions, dispatch]);

    return null;
}
